import React, { useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { GetTouch } from '../sections/GetTouch';
import { Testimonial } from '../sections/Testimonial';
import { Link } from 'react-router-dom';
import { FaqCareer } from '../sections/FaqCareer';

export const Career = () => {

    const developers = [
        {
            roleIcon: '/assets/images/saas-career.svg',
            role: 'Saas Developer',
            experience: '2 Years (Exp)',
            description: 'Join our product innovation team to build scalable SaaS solutions that solve real-world problems. Collaborate with cross-functional teams to design, develop, and deploy cloud-native applications that are secure, reliable, and built for global scale. ',
            detailBtn: 'READ MORE',
            path: '/saasDetail'
        },
        {
            roleIcon: '/assets/images/front-career.svg',
            role: 'Front End Developer',
            experience: '2 Years (Exp)',
            description: 'We’re looking for a Front End Developer who can bring creativity and precision to every interface. At IMUII, you’ll develop responsive, dynamic UIs using frameworks like React or Vue. Collaborate closely with designers and backend teams to deliver seamless user experiences that perform flawlessly across devices. ',
            detailBtn: 'READ MORE',
            path: '/frontEndDetail'
        },
        {
            roleIcon: '/assets/images/uiux-career.svg',
            role: 'UI / UX Designer',
            experience: '2 Years (Exp)',
            description: 'At IMUII, our UI/UX Designers craft digital experiences that are not only beautiful but also user-centric. From intuitive wireframes to engaging user flows, you’ll transform complex ideas into seamless, functional designs. We’re looking for a creative thinker who understands design systems, accessibility, and responsive behaviour.  ',
            detailBtn: 'READ MORE',
            path: '/UIUXDetail'
        },
        {
            roleIcon: '/assets/images/back-career.svg',
            role: 'Back End Developer',
            experience: '2 Years (Exp)',
            description: "At IMUII, our Back End Developers are the backbone of digital innovation. In this role, you'll build scalable, secure, and high-performance server-side applications that power seamless user experiences. From managing databases to creating robust APIs, your work ensures our platforms run smoothly and efficiently behind the scenes. You’ll collaborate with front-end teams, contribute to architecture decisions, and solve complex problems using modern frameworks and cloud technologies. If you're passionate about clean code and strong logic, this is where your skills will thrive. ",
            detailBtn: 'READ MORE',
            path: '/backEndDetail'
        },
        {
            roleIcon: '/assets/images/android-career.svg',
            role: 'Android Developer ',
            experience: '2 Years (Exp)',
            description: 'As an Android Developer at IMUII, you’ll play a key role in building innovative mobile applications tailored for the Android ecosystem.  ',
            detailBtn: 'READ MORE',
            path: '/androidDetail'
        },
        {
            roleIcon: '/assets/images/saas-career.svg',
            role: 'Saas Developer',
            experience: '2 Years (Exp)',
            description: 'Join our product innovation team to build scalable SaaS solutions that solve real-world problems. Collaborate with cross-functional teams to design, develop, and deploy cloud-native applications that are secure, reliable, and built for global scale. ',
            detailBtn: 'READ MORE',
            path: '/saasDetail'
        },
        {
            roleIcon: '/assets/images/front-career.svg',
            role: 'Front End Developer',
            experience: '2 Years (Exp)',
            description: 'We’re looking for a Front End Developer who can bring creativity and precision to every interface. At IMUII, you’ll develop responsive, dynamic UIs using frameworks like React or Vue. Collaborate closely with designers and backend teams to deliver seamless user experiences that perform flawlessly across devices. ',
            detailBtn: 'READ MORE',
            path: '/frontEndDetail'
        },
        {
            roleIcon: '/assets/images/uiux-career.svg',
            role: 'UI / UX Designer',
            experience: '2 Years (Exp)',
            description: 'At IMUII, our UI/UX Designers craft digital experiences that are not only beautiful but also user-centric. From intuitive wireframes to engaging user flows, you’ll transform complex ideas into seamless, functional designs. We’re looking for a creative thinker who understands design systems, accessibility, and responsive behaviour.  ',
            detailBtn: 'READ MORE',
            path: '/UIUXDetail'
        },
        {
            roleIcon: '/assets/images/android-career.svg',
            role: 'Android Developer ',
            experience: '2 Years (Exp)',
            description: 'As an Android Developer at IMUII, you’ll play a key role in building innovative mobile applications tailored for the Android ecosystem.  ',
            detailBtn: 'READ MORE',
            path: '/androidDetail'
        },
    ]


    const [visibleCount, setVisibleCount] = useState(6);
    const handleExpand = () => {
        setVisibleCount(prevCount => Math.min(prevCount + 6, developers.length));
    };
    
      const handleCollapse = () => {
        setVisibleCount(prevCount => Math.max(prevCount - 6, 6));
    };

  return (
    <>
        {/* Career Banner */}
        <section className='about-page'>
            <div className='about-bg'>
                <div className='about-shap-1 con-shap-c'>
                    <img src="../assets/images/whi-5.svg" alt="" />
                </div>
                <div className='about-shap-3'>
                    <img src="../assets/images/about-shap-1.png" alt="" />
                </div>
                <div className='about-shap-4'>
                    <img src="../assets/images/about-shap-2.png" alt="" />
                </div>
                <div className='about-shap-5 con-shap-c'>
                    <img src="../assets/images/about-shap-3.svg" alt="" />
                </div>
                <div className='career-shap-2'>
                    <img src="../assets/images/whi-3.svg" alt="" />
                </div>
                
                
                <Container>
                    <Row className='align-items-center'>
                        <div className='col-lg-5 d-lg-block d-none position-relative' data-aos="fade-right" data-aos-duration="2000">
                            <div className='career-img text-center'>
                                <img src="../assets/images/career-img.png" alt="" />
                            </div>

                            <div className='career-shap-3'>
                                <img src="../assets/images/career-shap-1.svg" alt="" />
                            </div>
                            <div className='career-shap-4'>
                                <img src="../assets/images/career-shap-2.svg" alt="" />
                            </div>

                            <div className='career-shap-11'>
                                <img src="../assets/images/white-arr.svg" alt="" />
                            </div>
                        </div>
                        <div className='col-xl-6 col-lg-5 padding-0' data-aos="fade-left" data-aos-duration="2000">
                            <div className='tech-content'>
                                <h2>Career With Us</h2>
                                <p>At IMUII, we believe in fostering talent and innovation. Join a team where your ideas matter, your growth is nurtured, and every challenge is an opportunity to shine. Be part of a culture that values curiosity, creativity, and collaboration. </p>
                            </div>
                        </div>
                    </Row>
                </Container>
            </div>
        </section>

        {/* A Few Opportunities Section */}
        <section className='opportunities_section'>
            <Container>
                <div className='opportunities-text' data-aos="fade-right" data-aos-duration="2000">
                    <h5>A Few Opportunities for You to Look Into</h5>
                    <h4>Explore diverse roles that challenge and inspire. At IMUII, we’re always on the lookout for passionate developers, designers, analysts, and innovators who want to build the future of technology.</h4>
                </div>

                <Row>
                    {
                        developers.slice(0, visibleCount).map((dev,index)=>(
                            <div key={index} className='col-lg-4 col-sm-6 developer-margin col-opportunities'>
                                <Link to={dev.path}>
                                    <div className="developer-card">
                                        <div className='developer-flex'>
                                            <div className='role-bg'>
                                                <img src={dev.roleIcon} alt="" />
                                            </div>
                                            <div className='developer-details'>
                                                <h4>{dev.role}</h4>
                                                <h6>{dev.experience}</h6>
                                            </div>
                                        </div>
                                        <div className='dev-description'>
                                            <p>{dev.description}</p>
                                        </div>
                                        <div className='dev-btn'>
                                            <button>{dev.detailBtn}</button>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        )) 
                    }
                </Row>
                
                <div className='d-flex justify-content-center flex-column'>
                    {visibleCount < developers.length && (
                        <div className='scroll-img' onClick={handleExpand}>
                        <img src="../assets/images/expend-arrow.svg" alt="" /> 
                        <p className='mb-0'>Click To Expand</p>
                        </div>
                    )} 
                    {visibleCount > 6 && (
                        <div className='scroll-img1' onClick={handleCollapse}>
                        <img src="../assets/images/expend-arrow.svg" alt="" />
                        <p className='mb-0'>Click To Compress</p>
                        </div>
                    )}
                </div>

            </Container>
        </section>

        {/* Career Bottom Banner */}
        <section className='career-banner-section'>
            <Container>
                <Row>
                    <div className='col-lg-12'>
                        <div className='career-mission-img' data-aos="zoom-in-up" data-aos-duration="2000">
                            <img src="../assets/images/mission-img.jpg" alt="" />
                        </div>
                    </div>
                    <div className='col-lg-6' data-aos="fade-right" data-aos-duration="2000">
                        <div className='mission-text'>
                            <h3>Grow With Us</h3>
                            <p>At IMUII, we believe careers thrive when curiosity meets opportunity. Whether you’re just starting out or looking to elevate your journey, we offer a space where innovation, learning, and collaboration come together. You’ll get to work with forward-thinking teams, on meaningful projects that make a difference. </p>
                        </div>
                    </div>
                    <div className='col-lg-6' data-aos="fade-left" data-aos-duration="2000">
                        <div className='mission-text'>
                            <h3>What We Look For </h3>
                            <p>We’re driven by passion and fueled by purpose. IMUII is always on the lookout for thinkers, doers, and problem-solvers who are ready to challenge the norm. If you bring creativity, adaptability, and a hunger to build great things—we want to hear from you. </p>
                        </div>
                    </div>
                </Row>
            </Container>
        </section>

        {/* FAQ Section */}
        <FaqCareer />

        {/* Get Touch Section */}
        <GetTouch />

        {/* Testimonial Section */}
        <Testimonial />
    </>
  )
}
